import * as React from 'react'
require('../base.module.scss')
import { BaseComponentProps } from '../Common/extractClassNamesFromProps'
import { extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'
import * as st from './Landmark.module.scss'

export const Landmark: React.ComponentType<BaseComponentProps> = props => {
    const className = extractClassNamesFromProps(props, st.landmark)
    return <div className={className}>{props.children}</div>
}

// Add displayName to preserve the component name on snapshot testing
Landmark.displayName = 'Landmark'
